import { useState, useEffect, useCallback } from 'react';

/**
 * Un hook personnalisé pour effectuer des requêtes fetch.
 *
 * @param {Function} fetchDataFunction La fonction qui effectue la requête.
 * @param {Array} params Les paramètres à passer à fetchDataFunction.
 * @returns {Object} Un objet contenant les données, l'état de chargement, et une éventuelle erreur.
 */
const useFetch = (fetchDataFunction, params) => {
  const [data, setData] = useState(null);
  const [metadata, setMetadata] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Utilisez useCallback pour mémoriser votre fonction de requête
  const triggerFetch = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await fetchDataFunction(...params);

      if(result.data?.data){
        setData(result.data.data); // Assurez-vous que fetchDataFunction renvoie les données attendues
        const meta = result.data
        delete meta.data
        setMetadata(meta)
      }else{
        setData(result.data); // Assurez-vous que fetchDataFunction renvoie les données attendues
        setMetadata({})
      }

    } catch (err) {
      setError({message : err.response.data.error, status : err.message});
    } finally {
      setIsLoading(false);
    }
  }, [params]);

  return { data, metadata, isLoading, error, fetchData: triggerFetch };
};

export default useFetch;